import { detectDominoesFromRGBA, type DetectOptions, type DetectionResult } from "../vision";

/** Minimal shape of the browser's `ImageData`, kept narrow so it is easy to fake in tests. */
export interface RgbaImage {
  data: Uint8ClampedArray;
  width: number;
  height: number;
}

/**
 * Run the domino detection pipeline over raw RGBA image data. This is a thin,
 * dependency-free wrapper so the UI layer never has to know about the vision
 * internals, and so it can be unit tested without a DOM/canvas.
 */
export function analyzeImage(
  image: RgbaImage,
  options?: DetectOptions,
): DetectionResult {
  return detectDominoesFromRGBA(image.data, image.width, image.height, options);
}
